export default __webpack_public_path__ + "static/media/p_wdt_c_5_6.6a8e731f.mp3";